import React from 'react';

const ProgressBar = (props) => {
  let estilo = { width: `${props.progress}%` };

  if (props.label.includes('Error')) {
    estilo = { backgroundColor: '#EC971F' };
  }

  return (
    <div className='total'>
      <div className='movil text-center' style={estilo}>
        <p>
          {estilo.backgroundColor ? (<i className='fa fa-frown-o' />) : null}
          {' '}
&nbsp;&nbsp;
          {props.label}
        </p>
      </div>
    </div>
  );
};

export default ProgressBar;
